
import axios from 'axios'
import Servers from "../../server"
export default{
    state: {
      providers: [],
    },
    mutations: {
      setProviders(state, data){
        state.providers = data
      }
    },
    getters: {
      getProviders(state){
        return state.providers
      }
    },
    actions: {
         getReports(context, body){
            return axios.get(
                Servers.serverApi +
                  "api/visitants/schedule/"+body.date1+"/"+body.date2+"/?limit=1500&page=0",
                {
                  responseType: "application/json",
                  headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                  }
                })
        },
         getReports2(context, data){
          return axios.get(
              `${Servers.serverApi}api/visitants/visitantReport?${data.body}`,
              {
                responseType: "application/json",
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token")
                }
              });
        }, 
      getReportCsv(context, data) {
           const query =
             data.body && data.body.trim() !== "" ? `?${data.body}` : "";

           const url = `${Servers.serverApi}api/visitants/visitantReportCsv${query}`;

          let response = axios.get(url,
              {
                responseType: "application/json",
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token")
                }
              });

          return response
        }, 
      async getProvidersList(context){
        let response =  await axios.get(Servers.serverApi + "api/providerTypes", {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        })

        context.commit('setProviders', response.data.data)
      },
      async getReportCommonArea(context, data){
        const url = `${Servers.serverApi}api/commonAreaVisitants?${data.body}`;
        let response = await axios.get(url, {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
        });
      return response

      }
    }
}